module.exports = __webpack_public_path__ + "images/5e43cee3d7e141e0112b51b0cce6e9d8-trendingImg2.png";